module.exports = __webpack_public_path__ + "static/img/order_phone@3x.5ce4b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order_phone@3x.png
// module id = YKHw
// module chunks = 1